import React, { Suspense, createContext, lazy } from 'react'
import { EventsManager } from './EventsManager'

const context = createContext(EventsManager)
const Provider = typeof window === 'undefined' ? () => null : lazy(() => import('./EventsProvider'))

function WorldEvents(props) {
  return (
    <Suspense fallback={null}>
      <Provider {...props} />
    </Suspense>
  )
}

export { WorldEvents, context }
